import { TooltipProvider } from '@sitewise/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useMemo, type ReactNode } from 'react';


import { createQueryClient } from './lib/query-client.js';
import { useAuthStore } from './stores/auth-store.js';

interface Props {
  children: ReactNode;
}

/**
 * Wires the global providers in a single place: TanStack Query, Radix
 * tooltip context, and a one-shot rehydration of the auth store from
 * localStorage on first mount.
 */
export function AppProviders({ children }: Props) {
  const queryClient = useMemo(() => createQueryClient(), []);

  useEffect(() => {
    useAuthStore.getState().hydrateFromStorage();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={250}>{children}</TooltipProvider>
    </QueryClientProvider>
  );
}
